import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import { PRIVACY_POLICY } from '../constants/legal.js';

interface PrivacyPolicyModalProps {
  open: boolean;
  onClose: () => void;
  onAccept: () => void;
}

const PrivacyPolicyModal: React.FC<PrivacyPolicyModalProps> = ({ open, onClose, onAccept }) => {
  const [hasViewedPolicy, setHasViewedPolicy] = useState(false);

  useEffect(() => {
    if (open) {
      setHasViewedPolicy(true);
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: { maxHeight: '80vh' }
      }}
    >
      <DialogTitle>
        <Typography variant="h5" component="div">
          Privacy Policy
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box
          sx={(theme) => ({
            height: '50vh',
            overflow: 'auto',
            pr: 2,
            '&::-webkit-scrollbar': {
              width: '8px',
            },
            '&::-webkit-scrollbar-track': {
              background: theme.palette.background.default,
            },
            '&::-webkit-scrollbar-thumb': {
              background: theme.palette.text.secondary,
              borderRadius: '4px',
            },
            '& .legal-markdown h1': { ...theme.typography.h4, marginBottom: 2 },
            '& .legal-markdown h2': { ...theme.typography.h5, marginTop: 2, marginBottom: 1.5 },
            '& .legal-markdown h3': { ...theme.typography.h6, marginTop: 2, marginBottom: 1 },
            '& .legal-markdown p': { ...theme.typography.body1, marginBottom: 1.5 },
            '& .legal-markdown ul': { paddingLeft: 3, marginBottom: 1.5 },
            '& .legal-markdown li': { marginBottom: 0.75 },
            '& .legal-markdown strong': { fontWeight: 700 },
          })}
        >
          <ReactMarkdown className="legal-markdown">
            {PRIVACY_POLICY}
          </ReactMarkdown>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={hasViewedPolicy}
              onChange={(e) => setHasViewedPolicy(e.target.checked)}
              disabled={!hasViewedPolicy}
              color="primary"
            />
          }
          label="I have read and agree to the Privacy Policy"
        />
        <Box sx={{ flexGrow: 1 }} />
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button
          onClick={onAccept}
          variant="contained"
          disabled={!hasViewedPolicy}
        >
          Accept
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PrivacyPolicyModal; 